export enum TileActionName {
  CLOSE = 'close',
  ADDCART = 'addToCart',
  WATCH = 'watch',
  EXTERNAL_LINK = 'externalLink',
  SOCIAL_SHARE = 'socialshare',
  PIP = 'pictureInPicture',
  CANCEL_EXPAND = 'cancelExpand',
}
